import { Component, AfterViewInit, OnInit, OnDestroy } from "@angular/core";
import { first } from "rxjs/operators";
import { Router } from "@angular/router";
import { from, Observable, Subscription } from "rxjs";
import {
  trigger,
  state,
  style,
  transition,
  animate,
} from "@angular/animations";
import { TopBarMenu } from "./top-bar-menu";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { KeycloakService } from "src/app/core/services/auth/keycloak.service";
import { NavBarHorizontalComponent } from "../nav-bar-horizontal/nav-bar-horizontal.component";
import { Notification } from "src/app/core/models/Notification";
import { NotificationService } from "src/app/core/services/WebSocket/notification.service";
import { WebSocketService } from "src/app/core/services/WebSocket/WebSocketService";
import { NotificationConsts } from 'src/app/core/models/NotificationConsts';
import { ToastrService } from 'ngx-toastr';
import { PushNotification, PushNotificationsService } from 'src/app/core/services/WebSocket/push.notification.service';
import { FormulaireDTO } from 'src/app/parametrage/core/model/formulaire-dto';
import { FormulaireService } from 'src/app/parametrage/core/service/formulaire.service';
import { Formulaire } from "src/app/parametrage/core/model/formulaire";

@Component({
  selector: "app-top-bar",
  templateUrl: "./top-bar.component.html",
  styleUrls: ["./top-bar.component.scss"],
  animations: [
    trigger("slide", [
      state("up", style({ height: 0 })),
      state("down", style({ height: "*" })),
      transition("up <=> down", animate(200)),
    ]),
  ],
})
export class TopBarComponent implements OnInit, OnDestroy, AfterViewInit {
  currentEmployee1: Employee = new Employee();
  notificationList: Notification[] = [];
  MyPermissions1: string[];
  menus1 = [];
  username: string = null;
  private eventSubscription: Subscription;
  
  formulaire: FormulaireDTO;
  formulaireTask: Formulaire;

  constructor(
    private _router: Router,
    private _navBarHorizontalComponent: NavBarHorizontalComponent,
    private _topBarService: TopBarMenu,
    private _keycloakService: KeycloakService,
    private _employeeService: EmployeeService,
    private _notificationService: NotificationService,
    private webSocketService: WebSocketService,
    private toastrService: ToastrService,
    private _pushNotificationsService: PushNotificationsService,
    private _formulaireService: FormulaireService
  ) {
    this._pushNotificationsService.requestPermission();
    this.getCurrentEmployee();
    this.menus1 = _topBarService.getMenuList();
    this.MyPermissions1 = _keycloakService.getAccessPermissions();
  }

  ngOnInit() {
    this.username = this._keycloakService.getUsername();
    this.getNotificationList();
    // S'abonner aux événements reçus
    this.eventSubscription = this.webSocketService
      .message$
      .subscribe((message: any) => {
        if (message) {
          switch (message.typeNotification) {
            case NotificationConsts.NOUVELLE_TACHE:
              
              this.getNotificationList();

              this.notify(message);
              this.toastrService.success(
                "Nouvelle tâche",
                "Nouvelle tâche reçue"
              );
              break;
          }

        }
      });
  }
  
  ngOnDestroy(): void {
    // Only unsubscribe: WebSocketService is root-scoped and must stay alive for the app
    if (this.eventSubscription) {
      this.eventSubscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
    this._topBarService.toggleActiveLink();
  }

  getNotificationList() {
    this._notificationService.loadUnreadNotifications(this.username).subscribe(
      (data) => {
        this.notificationList = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  markAsRead(notification: Notification) {
    this._notificationService
      .markAsRead(notification.id, this.username)
      .subscribe(
        (data) => {
          this.getNotificationList();
          //this.dossierInfo(notification.link)
          this.takeFormExecutionTask(notification)
        },
        (error) => {
          console.log(error);
        }
      );
  }


  markAllAsRead() {
    this._notificationService.markAllAsRead(this.username).subscribe(
      (data) => {
        this.getNotificationList();
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getCurrentEmployee() {
    this._employeeService.getCurrentEmployee().subscribe(
      (data) => {
        this.currentEmployee1 = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  logout() {

    localStorage.setItem("current_menu_header", "new_tableau_de_bord");
    localStorage.setItem("current_menu_header_changed", "true");
    this._navBarHorizontalComponent.clearMenu("new_tableau_de_bord");

    this.redirectUrl("/").then(() => {
      this._keycloakService.logout().subscribe({
        next: () => {
          console.log("Déconnexion réussie");
        },
        error: (error) => {
          console.error("Erreur lors de la déconnexion :", error);
        },
      });
    });
  }

  redirect(url: string)
  {
    this.redirectUrl(url).then(() => {
    });
  }
  
  redirectUrl(url: string): Promise<boolean> {
    return this._router.navigate([url]).then((success) => {
      if (success) {
        window.location.reload();
      }
      return success;
    });
  }

  toggle(currentMenu) {
    localStorage.setItem("current_menu_header", currentMenu.code);
    localStorage.setItem("current_menu_header_changed", "true");
    this._navBarHorizontalComponent.clearMenu(currentMenu.code);

    this.menus1.forEach((element) => {
      if (element === currentMenu) {
        element.class = {
          "margin-left": "10px",
          color: "white",
          "font-weight": "bold",
        };
      } else {
        element.class = {
          "margin-left": "10px",
          color: "white",
          "font-weight": "normal",
        };
      }
    });
  }

  

  notify(notification) {
    let data: Array<any> = [];

    data.push({
      title: notification.typeNotification,
      alertContent: notification.content.replace(/(\r\n|\n|\r|<br>)/gm, '')
    });

    this._pushNotificationsService.generateNotification(data);
  }

  
  dossierInfo(requestId) {
    this._formulaireService.takeFormInfoRequest(requestId).subscribe(
      (data) => {
        this.formulaire = data;
        this._router.navigateByUrl(this.formulaire.url);
      },
      (error) => {
        console.log(error);
      }
    );
  }

  
  takeFormExecutionTask(notification: Notification) {
    let taskId = notification.link.split("/")[1];
    this._formulaireService.takeFormExecutionTask(taskId).subscribe(
      (data) => {
        this.formulaireTask = data;
        this._router.navigateByUrl(
          this.formulaireTask.lien + notification.link
        );
      },
      (error) => {
        console.log(error);
      }
    );
  }


}
